import { ObservableArray, View } from "binder"
import { KeepingPartProduct, WarehouseKeepingPartDetailViewModel } from "./warehouseKeepingPartDetail-viewModel"

export class WarehouseKeepingPartDetailView extends View<WarehouseKeepingPartDetailViewModel>{
    GetViewUniqueId(): string {
        return "V-114903CF-4114-483F-A0AF-8AB2E528737F"
    }
    loadHtml(): string {
        let element = require('./warehouseKeepingPartDetail.html').default;
        let style = require('./warehouseKeepingPartDetail.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseKeepingId(v: string) { this._warehouseKeepingId = v; } public get warehouseKeepingId(): string { return this._warehouseKeepingId;} private _warehouseKeepingId: string;
    public set keepingPartId(v: string) { this._keepingPartId = v; } public get keepingPartId(): string { return this._keepingPartId;} private _keepingPartId: string;
    public set createTime(v: moment.Moment) { this._createTime = v; } public get createTime(): moment.Moment { return this._createTime;} private _createTime: moment.Moment;
    public set endTime(v: moment.Moment) { this._endTime = v; } public get endTime(): moment.Moment { return this._endTime;} private _endTime: moment.Moment;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set keepingPartProducts(v: ObservableArray<KeepingPartProduct>) { this._keepingPartProducts = v; } public get keepingPartProducts(): ObservableArray<KeepingPartProduct> { return this._keepingPartProducts;} private _keepingPartProducts: ObservableArray<KeepingPartProduct>;
    public set totalCountedAmount(v: number) { this._totalCountedAmount = v; } public get totalCountedAmount(): number { return this._totalCountedAmount;} private _totalCountedAmount: number;
    public set totalAmount(v: number) { this._totalAmount = v; } public get totalAmount(): number { return this._totalAmount;} private _totalAmount: number;
    public set hasCountAccess(v: boolean) { this._hasCountAccess = v; } public get hasCountAccess(): boolean { return this._hasCountAccess;} private _hasCountAccess: boolean;
    public set hasConfirmAccess(v: boolean) { this._hasConfirmAccess = v; } public get hasConfirmAccess(): boolean { return this._hasConfirmAccess;} private _hasConfirmAccess: boolean;
    

    updatePart() {
        this.dataContext.updatePart();
    }

    finalConfirm() {
        this.dataContext.finalConfirm();
    }

    close() {
        this.dataContext.closePopup();
    }
}
